import Layout from "Components/Layout";
import React, { useEffect, useState } from "react";
import Styles from "./Styles.module.css";
import { AddFaq, UpdateFaqs } from "Services/ServiceRequest";
import Swal from "sweetalert2";
import Loader from "Components/Loader/subload/loader";
import { useNavigate, useParams, useLocation } from "react-router";
function Page() {
    const { type } = useParams();
    const Navigate = useNavigate();
    const [Active, setActive] = useState("en");
    const location = useLocation();
    const [error_msg, setErrormsg] = useState(null);
    const [loading, setLoading] = useState(false);

    const [body, setBody] = useState({
        question: { en: "", es: "", fr: "" },
        answer: { en: "", es: "", fr: "" },
    });
    useEffect(() => {
        if (error_msg) {
            setActive(error_msg?.Active);
        }
    }, [error_msg]);
    useEffect(() => {
        if (type == "edit") {
            setBody({
                question: location.state?.question,
                answer: location.state?.answer,
            });
        }
    }, [type]);
    const Buttons = [
        { label: "English", value: "en" },
        { label: "French", value: "fr" },
        { label: "Spanish", value: "es" },
    ];
    const ChangeHandler = (value, key) => {
        setBody((prev) => ({
            ...prev,
            [key]: { ...prev[key], [Active]: value.replace("\n", " ") },
        }));
    };
    const validateForm = () => {
        if (!body.question.en) {
            return {
                Active: "en",
                type: "question",
                message: "Question is required ",
            };
        }
        // Check if any of the message fields are missing
        if (!body.answer.en) {
            return {
                Active: "en",
                type: "answer",
                message: "Answer is required ",
            };
        }
        if (!body.question.fr) {
            return {
                Active: "fr",
                type: "question",
                message: "Question is required ",
            };
        }
        if (!body.answer.fr) {
            return {
                Active: "fr",
                type: "answer",
                message: "Answer is required ",
            };
        }
        if (!body.question.es) {
            return {
                Active: "es",
                type: "question",
                message: "Answer is required ",
            };
        }

        if (!body.answer.es) {
            return {
                Active: "es",
                type: "answer",
                message: "Answer is required",
            };
        }

        // If all fields are valid, return null or an empty object
        return null;
    };
    const onSubmit = async (event) => {
        event.preventDefault();
        let Errors = validateForm();
        if (Errors) {
            setErrormsg(Errors);
            setActive(Errors?.Active);
            return;
        }

        try {
            setLoading(true);
            let response;
            if (type == "edit") {
                response = await UpdateFaqs(location.state?.FAQId, {
                    ...body,
                });
            } else {
                response = await AddFaq(body);
            }

            setLoading(false);
            setBody({
                question: { en: "", es: "", fr: "" },
                answer: { en: "", es: "", fr: "" },
            });
            setActive("en");
            setErrormsg(null);
            if (response?.data?.Status === 1) {
                Swal.fire({
                    title: "Success",
                    text: response?.data?.Message || "FAQ Added Successfull",
                    icon: "success",
                });
            }
            Navigate(-1);
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };
    return (
        <Layout Active={"FAQ"}>
            {loading && <Loader />}
            <div className={`Main_container ${Styles["container"]}`}>
                <h3>{type == "edit" ? "Edit" : "Add"} FAQ </h3>
                <div className="request_Tabs">
                    {Buttons.map((item) => (
                        <button
                            className={Active == item.value ? "Active-tab" : ""}
                            onClick={() => setActive(item.value)}>
                            {item?.label}
                        </button>
                    ))}
                </div>
                <form onSubmit={onSubmit}>
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">Question</label>
                        <input
                            type="text"
                            value={body["question"][Active]}
                            onChange={(e) =>
                                ChangeHandler(e.target.value, "question")
                            }
                        />
                    </div>
                    {error_msg &&
                        error_msg.type == "question" &&
                        error_msg.Active == Active && (
                            <span style={{ color: "red" }}>
                                {error_msg?.message}
                            </span>
                        )}
                    <div className={Styles["form_control"]}>
                        <label htmlFor="">Answer</label>
                        <textarea
                            type="text"
                            cols={4}
                            rows={7}
                            value={body["answer"][Active]}
                            onChange={(e) =>
                                ChangeHandler(e.target.value, "answer")
                            }
                        />
                    </div>
                    {error_msg &&
                        error_msg.type == "answer" &&
                        error_msg.Active == Active && (
                            <span style={{ color: "red" }}>
                                {error_msg?.message}
                            </span>
                        )}
                    <input type="submit" />
                </form>
            </div>
        </Layout>
    );
}

export default Page;
